import React from 'react';
import { cn } from '@/lib/utils';

const MAP = {
  'New Import': 'bg-muted text-muted-foreground border-border',
  'Validated': 'bg-info/10 text-info border-info/30',
  'Assigned': 'bg-primary/10 text-gold-deep border-primary/30',
  'Contact Scheduled': 'bg-primary/10 text-gold-deep border-primary/30',
  'Contacted': 'bg-primary/10 text-gold-deep border-primary/30',
  'Promise to Pay': 'bg-warning/15 text-warning border-warning/40',
  'Payment Plan Active': 'bg-success/15 text-success border-success/40',
  'Paid / Closed': 'bg-success/15 text-success border-success/40',
  'Broken Promise': 'bg-destructive/10 text-destructive border-destructive/30',
  'Dispute Hold': 'bg-destructive/10 text-destructive border-destructive/30',
  'Complaint Hold': 'bg-destructive/10 text-destructive border-destructive/30',
  'Legal Candidate': 'bg-secondary/80 text-background border-secondary',
  'Legal In Progress': 'bg-secondary/80 text-background border-secondary',
  'Uncollectible': 'bg-muted text-muted-foreground border-border',
  'connected': 'bg-success/15 text-success border-success/40',
  'degraded': 'bg-warning/15 text-warning border-warning/40',
  'failed': 'bg-destructive/10 text-destructive border-destructive/30',
  'blocked': 'bg-destructive/10 text-destructive border-destructive/30',
  'success': 'bg-success/15 text-success border-success/40',
};

export const StatusChip = ({ status, className }) => (
  <span className={cn('inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-md border', MAP[status] || 'bg-muted text-muted-foreground border-border', className)}>
    <span className={cn('h-1.5 w-1.5 rounded-full', (MAP[status] || '').split(' ')[1]?.replace('text', 'bg') || 'bg-muted-foreground')} />
    {status}
  </span>
);

export default StatusChip;
